import { CommentPanelStatus } from "components/common/comments/interface";
import { eHierarchyLevel } from "functions/api/enums";
import { cloneDeep } from "lodash";
import { getHierarchyPrefix } from "../getHierarchyPrefix";
import { hcr_buildParentTemplates } from "../hcr_buildParentTemplates";
import { HierarchyContextProps, IHierarchyActionLoadHierarchy } from "../interface";

/**
 * Loads hierarchy data into state and rebuilds the parent template cache.
 *
 * @param state - The current hierarchy context state.
 * @param action - The load-hierarchy action to apply.
 * @returns The updated hierarchy context state.
 */
export const hcr_loadHierarchy = (
  state: HierarchyContextProps,
  action: IHierarchyActionLoadHierarchy,
): HierarchyContextProps => {
  const hierarchyNodes = [
    ...state.hierarchyNodes.filter(
      (h) => ![...action.hierarchyNodes.map((hn) => hn.id), action.hierarchy.id].includes(h.id),
    ),
    action.hierarchy,
    ...action.hierarchyNodes.filter((h) => h.level !== eHierarchyLevel.TopLevel),
  ];

  const commentPanelStatus: CommentPanelStatus = state.commentPanelStatus.showComments
    ? {
        showComments: false,
        highlightCommentId: "",
        activeRelatedTo: "",
        commentFilter: "all",
      }
    : state.commentPanelStatus;

  return {
    ...state,
    changed: false,
    id: action.hierarchy.id,
    hierarchy: action.hierarchy,
    savedHierarchy: cloneDeep(action.hierarchy),
    isNameChanged: false,
    prefix: getHierarchyPrefix(action.hierarchy.level),
    hierarchyNodes,
    parentTemplates: hcr_buildParentTemplates(action.hierarchy, hierarchyNodes),
    accessRights: action.accessRights,
    tlfItemIndex: action.hierarchy.id === state.hierarchy?.id ? state.tlfItemIndex : null,
    isSubscribed: action.isSubscribed,
    commentPanelStatus,
  };
};
